<!-- Template taken from AgGrid docs here: https://www.ag-grid.com/javascript-data-grid/column-headers/#provided-component -->
<div class="ag-cell-label-container" role="presentation">
    <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
        <span data-ref="eText" class="ag-header-cell-text">
            <div>
                @if (params.checkboxFunction) {
                    <mat-checkbox
                        [disabled]="params.disabled"
                        (change)="params.checkboxFunction($event)"
                        color="primary"
                    >
                    </mat-checkbox>
                }
                {{ params.displayName }}
            </div></span
        >
        <span
            data-ref="eFilter"
            class="ag-header-icon ag-header-label-icon ag-filter-icon ag-hidden"
            aria-hidden="true"
            ><span
                class="ag-icon ag-icon-filter"
                unselectable="on"
                role="presentation"
            ></span
        ></span>
        <span class="ag-sort-indicator-container" data-ref="eSortIndicator">
            <span
                data-ref="eSortOrder"
                class="ag-sort-indicator-icon ag-sort-order ag-hidden"
                aria-hidden="true"
            ></span>
            <span
                data-ref="eSortAsc"
                class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden"
                aria-hidden="true"
                ><span
                    class="ag-icon ag-icon-asc"
                    unselectable="on"
                    role="presentation"
                ></span
            ></span>
            <span
                data-ref="eSortDesc"
                class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden"
                aria-hidden="true"
                ><span
                    class="ag-icon ag-icon-desc"
                    unselectable="on"
                    role="presentation"
                ></span
            ></span>
            <span
                data-ref="eSortMixed"
                class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden"
                aria-hidden="true"
                ><span
                    class="ag-icon ag-icon-none"
                    unselectable="on"
                    role="presentation"
                ></span
            ></span>

            <span
                data-ref="eSortNone"
                class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden"
                aria-hidden="true"
                ><span
                    class="ag-icon ag-icon-none"
                    unselectable="on"
                    role="presentation"
                ></span></span
        ></span>
    </div>
</div>
